var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"timesheet-skeleton-exp-panel",attrs:{"loading":"","type":"timesheet-exp-panel-group-with-divder@4, timesheet-exp-panel-group","types":{
    'timesheet-exp-panel-group-with-divder':
      'timesheet-exp-panel-group, divider',
    'timesheet-exp-panel-group': 'timesheet-exp-panel-header, expand-icon',
    'timesheet-exp-panel-header': 'group-name, group-statistic',
    'group-name': 'heading',
    'group-statistic': 'single-stat@3',
    'single-stat': 'avatar, text',
    'expand-icon': 'avatar',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }